<template>
  <div id="trainer-primary-schools">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="trainer-schools-table" fluid>
      <b-row class="mt-4">
        <b-col cols="6" class="mr-4">
          <br />
          <b-col>
            <h4 class="subtitle">
              Trainer's Current Primary Schools ({{ schoolsTable.length || 0 }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="trainerPrimarySchoolsFields"
              :items="schoolsTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(school_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditPrimarySchool',
                    params: { id: row.item.school_uuid },
                  }"
                  >{{ row.item.school_name }}</b-link
                >
                <br />
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.id.toString()"
                  v-if="isAdmin || isSRC"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateTrainerPrimarySchool(row)"
                >
                  <b-form-radio :value="true">Y</b-form-radio>
                  <b-form-radio :value="false">N</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  v-if="isAdmin || isSRC"
                  @click.stop="deleteTrainerPrimarySchool(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="m-4">
                <b-pagination
                  :total-rows="schoolsTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col cols="1"></b-col>
        <b-col v-if="isAdmin || isSRC" cols="4">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Primary Schools</h4>
            <div>
              <name-search
                table="primary-schools"
                parent="trainer-primary-schools"
              ></name-search>
            </div>
            <br />
            <div v-if="searchedSchools.length">
              <b-col>
                <h6 class="subtitle">
                  Results: {{ searchedSchools.length }} primary schools found
                </h6>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="trainer-schools-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a primary school!</b-alert
                  >
                  <b-alert :show="showError" dismissible variant="warning">
                    Something went wrong. Please refresh and try again, or
                    contact the site admin.
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="searchedSchools"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(school_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{
                      name: 'EditPrimarySchool',
                      params: { id: row.item.uuid },
                    }"
                    >{{ row.item.school_name }}</b-link
                  >
                  <br />
                </template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link
                    class="add"
                    @click.stop="addPrimarySchoolToTrainer(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="searchedSchools.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TrainerService from "../services/TrainerService";
import NameSearch from "@/components/NameSearch";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TrainerPrimarySchools",
  mixins: [flash, scrollTo],
  components: {
    NameSearch,
  },
  data() {
    return {
      trainerId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      trainerPrimarySchoolsFields: [
        { key: "school_name", label: "Name", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      searchResultsFields: [
        { key: "school_name", label: "Name", sortable: true },
        { key: "id", label: "ADD" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINER_PRIMARY_SCHOOLS: "trainers/GET_TRAINER_PRIMARY_SCHOOLS",
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
      RESET_SCHOOLS_STATE: "primarySchools/RESET_SCHOOLS_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateTrainerPrimarySchool(params) {
      const payload = await {
        id: params.item.id,
        primary_school_uuid: params.item.primary_school_uuid,
        trainer_uuid: this.$route.params.trainer_uuid,
        active: !params.item.active,
      };
      await TrainerService.updateTrainerPrimarySchool(payload);
      await this.GET_TRAINER_PRIMARY_SCHOOLS();
    },
    async addPrimarySchoolToTrainer(params) {
      console.log(params);
      const payload = await {
        primary_school_uuid: params.item.uuid,
        trainer_uuid: this.$route.params.id,
        active: true,
      };
      await TrainerService.addTrainerPrimarySchool(payload);
      await this.scrollTo("trainer-schools-alert");
      await this.flashSuccess();
      await this.GET_TRAINER_PRIMARY_SCHOOLS();
    },
    async deleteTrainerPrimarySchool(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this school from this trainer?"
      );
      console.log(params);
      if (confirmDelete) {
        await TrainerService.deleteTrainerPrimarySchool(params);
        await this.GET_TRAINER_PRIMARY_SCHOOLS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      getGeo: "searches/getGeo",
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    schoolsTable: {
      get() {
        console.log(
          "trainer pschools: ",
          this.$store.state.trainers.trainerPrimarySchools
        );
        return this.$store.state.trainers.trainerPrimarySchools;
      },
    },
    searchedSchools: {
      get() {
        return this.$store.state.primarySchools.schools;
      },
    },
  },
  created() {
    this.GET_TRAINER_PRIMARY_SCHOOLS();
    this.RESET_SCHOOLS_STATE();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}

table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
